import classNames from 'classnames'

import type { LinkType } from 'types'
import Link from 'content-components/_Primatives/Link'
import style from './style.scss'

export type Props = {
  className?: string
  links: LinkType[]
}

function Breadcrumbs({ className, links }: Props) {
  return (
    <nav className={classNames(style.wrapper, className)}>
      <ul className={style.menu}>
        {links.map(({ url, text }) => (
          <li key={text} className={style.menuItem}>
            <Link className={style.link} url={url}>
              {text}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default Breadcrumbs
